import React, { useState, useEffect, useRef } from 'react';
import { withCookies } from 'react-cookie';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Traductor from '../Traductor';
import '../../css/components/auctions/AuctionBubbles.css';
import VehicleService from '../../services/VehicleService';
import ParseService from '../../services/ParseService';
import Globals from '../../Globals';

import * as filtersActions from '../../redux/actions/filters';
import { filterFavorite, filterBidden } from '../../constants/Filters';

function AuctionBubbles({
    history,
    cookies,
    listItems,
    reduxInitialFilters,
    setFilters: setReduxFilters,
}) {
    const [favoritesCount, setFavoritesCount] = useState(0);
    const [bidsCount, setBidsCount] = useState(0);
    const mounted = useRef();

    const routeToFavorites = () => {
        setReduxFilters({ ...reduxInitialFilters, [filterFavorite]: true });
        history.push({
            pathname: Globals.APPLICATION_PATH.AUCTION,
        });
    };

    const routeToBids = () => {
        setReduxFilters({ ...reduxInitialFilters, [filterBidden]: true });
        history.push({
            pathname: Globals.APPLICATION_PATH.AUCTION,
        });
    };

    const GetFavoritesCount = async () => {
        await new VehicleService()
            .getFavoritesCount(cookies.get(Globals.COOKIES.JWT).AccessToken)
            .then(response => {
                if (response && mounted.current) {
                    var count = new ParseService().Parse(response.body.Result);
                    setFavoritesCount(count);
                }
            })
            .catch(function (error) {
                //Error
            });
    };

    const GetBidsCount = async () => {
        var url = process.env.REACT_APP_AWS_BIDS_COUNT_BY_USER;
        var IdUser = cookies.get(process.env.REACT_APP_USER_ID)
            ? cookies.get(process.env.REACT_APP_USER_ID).toUpperCase()
            : null;
        var apikeyname = process.env.REACT_APP_AWS_BIDS_APIKEY_NAME;
        var apikeyvalue = process.env.REACT_APP_AWS_BIDS_APIKEY_VALUE;
        var bid = {};
        bid.IdUser = IdUser;
        bid.IdGroups = [];
        //bid.TipoPujas = "G"; //G Activas, P Perdidas
        if (listItems != null && listItems.length > 0) {
            listItems.map(SubastaActual =>
                bid.IdGroups.push(SubastaActual.AgrupationVersion)
            );
        }
        if (bid.IdGroups.length > 0 && bid.IdUser != null) {
            await new VehicleService()
                .getBidsCount(
                    url,
                    apikeyname,
                    apikeyvalue,
                    bid,
                    cookies.get(Globals.COOKIES.JWT).AccessToken
                )
                .then(response => {
                    if (response && mounted.current) {
                        setBidsCount(response.length);
                    }
                })
                .catch(function (error) {
                    //Error
                });
        } else {
            setBidsCount(0);
        }
    };

    useEffect(() => {
        mounted.current = true;
        if (listItems != null && listItems.length > 0) {
            GetFavoritesCount();
            GetBidsCount();
        }

        return () => {
            mounted.current = false;
        };
    }, [listItems]);

    let t = new Traductor();
    return (
        <div className="c-auction-bubbles">
            <div className="o-layout__item u-1/1 u-mt-xlarge u-mb-xlarge">
                <div className="o-layout">
                    <div
                        className="o-layout__item u-2/12 u-3/12@l u-4/12@m u-1/2@s c-auction-bubbles__item"
                        onClick={e => routeToFavorites()}
                    >
                        <div className="c-auction-bubbles__bubble">
                            {favoritesCount}
                        </div>
                        <span className="c-auction-bubbles__body">
                            {t.getTraduction('Favourits')}
                        </span>
                    </div>
                    <div
                        className="o-layout__item u-2/12 u-3/12@l u-4/12@m u-1/2@s c-auction-bubbles__item"
                        onClick={e => routeToBids()}
                    >
                        <div className="c-auction-bubbles__bubble">
                            {bidsCount}
                        </div>
                        <span className="c-auction-bubbles__body">
                            {t.getTraduction('Bids')}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = state => ({
    reduxInitialFilters:
        state.filters[Globals.APPLICATION_PATH.AUCTION].initial,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
    ...bindActionCreators({ ...filtersActions }, args => {
        //inject key with page route to actions
        return dispatch({
            ...args,
            route: Globals.APPLICATION_PATH.AUCTION,
        });
    }),
});

export default withCookies(
    connect(mapStateToProps, mapDispatchToProps)(AuctionBubbles)
);
